import type {FormMakerState} from '@FormMakerReact/form-maker.types';

export enum SaveStateKind {
  SAVING = 'saving',
  FAILED = 'failed',
  UNSAVED = 'unsaved',
  AUTOSAVE_OFF = 'autosave-off',
  SAVED = 'saved',
}

export interface SaveStateContext {
  isDraft: boolean;
}

export interface SaveBadgeProps {
  state: FormMakerState;
  onRetry: () => Promise<boolean>;
}
